import { createAction } from '/@/store/utils';

export const trackEvent = createAction('TRACK_EVENT');
